if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector(
          '[type="submit"], .ito_atc__button'
        );

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        let flagProductPage = true;
        window.location.href.split("/").forEach((segment, index) => {
          if (segment === "products") {
            flagProductPage = false;
          }
        });
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        if (!flagProductPage) {
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.classList.add("loading");
          this.querySelector(".loading__spinner").classList.remove("hidden");
          this.querySelector(".atc__text")?.classList.add("zoomout");
          this.querySelector(".atc__text")?.classList.remove("fadeInDown");
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status == 422 && flagProductPage) {
              this.handleErrorMessage(response.description);
              return;
            } 
            if (flagProductPage) {
              setTimeout(() => {
                console.log("add product");
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.classList.add("loading");
                this.querySelector(".loading__spinner").classList.remove(
                  "hidden"
                );
                this.querySelector(".atc__text")?.classList.add("zoomout");
                this.querySelector(".atc__text")?.classList.remove(
                  "fadeInDown"
                );
              }, 10);
              setTimeout(() => {
                this.submitButton.setAttribute("aria-disabled", false);
                this.submitButton.classList.remove("loading");
                this.querySelector(".loading__spinner").classList.add("hidden");
                this.querySelector(".atc__text")?.classList.remove("zoomout");
                this.querySelector(".atc__text")?.classList.add("fadeInDown");
                if (response.status) {
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: "product-form",
                    productVariantId: formData.get("id"),
                    errors: response.errors || response.description,
                    message: response.message,
                  });
                  this.handleErrorMessage(response.description);

                  const soldOutMessage =
                    this.submitButton.querySelector(".sold-out-message");
                  if (!soldOutMessage) return;
                  this.submitButton.setAttribute("aria-disabled", true);
                  this.submitButton
                    .querySelector("span")
                    .classList.add("hidden");
                  soldOutMessage.classList.remove("hidden");
                  this.error = true;
                  return;
                } else if (!this.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }

                if (!this.error)
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: "product-form",
                    productVariantId: formData.get("id"),
                    cartData: response,
                  });
                this.error = false;
                const quickAddModal = this.closest("quick-add-modal");
                if (quickAddModal) {
                  document.body.addEventListener(
                    "modalClosed",
                    () => {
                      setTimeout(() => {
                        this.cart.renderContents(response);
                      });
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  this.cart.renderContents(response);
                }
                document.dispatchEvent(new Event("ProductAdded"));
                
              }, 20);
            } 
            else {
              
              if (response.status) {
                console.log("Initiating addition to Cart");
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.querySelector("span").classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  cartData: response,
                });
              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
              document.dispatchEvent(new Event("ProductAdded"));
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
            this.querySelector(".atc__text").classList.remove("zoomout");
            this.querySelector(".atc__text").classList.add("fadeInDown");
            // document.dispatchEvent(new Event("ProductAdded"));
          });
      }

      handleErrorMessage(errorMessage = false) {
        console.log("Inside here !", this);
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          const errorMessageSpan = document.querySelector(
            "span.product-form__error-message.getMSG_err_pro"
          );
          if (errorMessageSpan) {
            errorMessageSpan.textContent = errorMessage;

            if (screen.width < 600) {
              // Calculate the target scroll position
              var targetScrollPosition = errorMessageSpan.offsetTop + 900;

              // Smooth scroll animation
              var startTime = null;
              var duration = 300;

              function animateScroll(currentTime) {
                if (startTime === null) {
                  startTime = currentTime;
                }

                var elapsed = currentTime - startTime;
                var progress = Math.min(elapsed / duration, 1);

                // Ease in-out function for smooth scroll
                function easeInOutQuad(t) {
                  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
                }

                // Calculate the new scroll position
                var newPos =
                  easeInOutQuad(progress) *
                    (targetScrollPosition - window.scrollY) +
                  window.scrollY;

                // Apply the new scroll position
                document.documentElement.scrollTop = newPos;
                document.body.scrollTop = newPos;

                if (progress < 1) {
                  requestAnimationFrame(animateScroll);
                }
              }

              // Initiate the scroll animation
              // requestAnimationFrame(animateScroll);
            }
          }
          else {
            console.log("Not found");
          }

          const customErrorMessage = document.querySelector(
            ".custom_new_errMsg2"
          );
          if (customErrorMessage) {
            customErrorMessage.classList.remove("hidden");
            // setTimeout(() => {
            //   if (errorMessageSpan) {
            //     errorMessageSpan.textContent = "";
            //   }
            //   if (customErrorMessage) {
            //     customErrorMessage.classList.add("hidden");
            //   }
            // }, 10000);
          }
        } else {
          console.log("Here ?");
        }
      }
    }
  );
}
